module.exports = __webpack_public_path__ + "img/gb9113_26.prt.71872a4d.jpg";